import { type AdvantageItem } from '../types';
import { APP_NAME } from '@glow/shared/lib/constants';

export function useMasterProblemItems(): AdvantageItem[] {
  const { staticUrl } = useRuntimeConfig().public;
  return [
    {
      iconUrl: `${staticUrl}/landing/difference4.png`,
      title: 'Высокая конкуренция',
      text: `
      Выделяйся в своем городе за счет удобства для клиента. Просмотр
      расписания, портфолио и онлайн-записи без твоего участия
    `,
      color: '#f1f1ff',
    },
    {
      iconUrl: `${staticUrl}/landing/forwhom4.png`,
      title: 'Много рутины',
      text: `
      Сохрани силы для важных вещей. Упростим повседневную работу — от
      напоминаний услуги до записи клиента
    `,
      color: '#f1f6ff',
    },
    {
      iconUrl: `${staticUrl}/landing/difference1.png`,
      title: 'Сложность в продвижении',
      text: `
      Экономь до 35% личного времени. ${APP_NAME} ежедневно занимается привлечением
      новых клиентов
    `,
      color: '#fcf5fc',
    },
    {
      iconUrl: `${staticUrl}/landing/why1.png`,
      title: 'Возврат клиентов',
      text: `
      Создавай персональные акции и предложения. База клиентов и рассылка
      уведомлений оповестят людей и напомнят о будущей записи
    `,
      color: '#f2f3fc',
    },
  ];
}
